/**
 * Core API exports - Centralized API client
 */
export { default as apiClient } from './client';
